module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.da61d7ef302b8bf871dd.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Regular-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.svg
// module chunks = styles